import React from 'react'
import classnames from 'classnames'

/**
 * Common segmented toggle component. Renders a row of options; one can be selected.
 *
 * @param {Object} props
 * @param {Array<{ value: string, label: React.ReactNode, icon?: React.ReactNode }>} props.options - Option list
 * @param {string} props.value - Current selected value (must match one option's value)
 * @param {function(string): void} props.onChange - Called when selection changes
 * @param {string} [props.className] - Extra class for the root element
 * @param {string} [props.name] - Name for accessibility (e.g. aria-label context)
 */
const Toggle = ({ options = [], value, onChange, className, name = 'toggle' }) => {
  return (
    <div
      className={classnames('Toggle', className)}
      role='group'
      aria-label={name}
    >
      {options.map((option) => {
        const isSelected = option.value === value
        return (
          <button
            key={option.value}
            type='button'
            role='radio'
            aria-checked={isSelected}
            aria-label={typeof option.label === 'string' ? option.label : option.value}
            className={classnames('Toggle__Option', { 'is-selected': isSelected })}
            onClick={() => onChange(option.value)}
          >
            {option.icon != null && (
              <span className='Toggle__OptionIcon' aria-hidden>
                {option.icon}
              </span>
            )}
            <span className='Toggle__OptionLabel'>{option.label}</span>
          </button>
        )
      })}
    </div>
  )
}

export default Toggle
